export const Monogram = ({ className = "h-10 w-10", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="1" y="1" width="62" height="62" fill="none" stroke={light ? "#FAF8F5" : "#1A1816"} strokeWidth="1" />
    <text x="32" y="40" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="26" fill={light ? "#FAF8F5" : "#1A1816"}>US</text>
    <line x1="20" y1="47" x2="44" y2="47" stroke="#A88350" strokeWidth="1.2" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <Monogram light={light} />
    <span className="leading-tight">
      <span className={`block font-display text-xl tracking-wide ${light ? "text-[#FAF8F5]" : "text-[#1A1816]"}`}>Ulyana Shmidt</span>
      <span className={`block text-[11px] tracking-[0.3em] uppercase ${light ? "text-[#CDBFA8]" : "text-[#6B645C]"}`}>Personal Stylist · NYC</span>
    </span>
  </span>
);
